var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewJsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6F7F7",
    fillRule: "nonzero",
    d: "M16,3 C23.1814516,3 29,8.81854839 29,16 C29,23.1814516 23.1814516,29 16,29 C8.81854839,29 3,23.1814516 3,16 C3,8.81854839 8.81854839,3 16,3 Z M23.5483871,17.4677419 L23.5483871,14.5322581 C23.5483871,14.1863108 23.2653021,13.9032258 22.9193548,13.9032258 L18.0967742,13.9032258 L18.0967742,9.08064516 C18.0967742,8.7346979 17.8136892,8.4516129 17.4677419,8.4516129 L14.5322581,8.4516129 C14.1863108,8.4516129 13.9032258,8.7346979 13.9032258,9.08064516 L13.9032258,13.9032258 L9.08064516,13.9032258 C8.7346979,13.9032258 8.4516129,14.1863108 8.4516129,14.5322581 L8.4516129,17.4677419 C8.4516129,17.8136892 8.7346979,18.0967742 9.08064516,18.0967742 L13.9032258,18.0967742 L13.9032258,22.9193548 C13.9032258,23.2653021 14.1863108,23.5483871 14.5322581,23.5483871 L17.4677419,23.5483871 C17.8136892,23.5483871 18.0967742,23.2653021 18.0967742,22.9193548 L18.0967742,18.0967742 L22.9193548,18.0967742 C23.2653021,18.0967742 23.5483871,17.8136892 23.5483871,17.4677419 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F7F7",
    fillOpacity: 0.15,
    fillRule: "nonzero",
    d: "M16,32 C24.836556,32 32,24.836556 32,16 C32,7.163444 24.836556,0 16,0 C7.163444,0 0,7.163444 0,16 C0,24.836556 7.163444,32 16,32 Z M16,30 C8.2680135,30 2,23.7319865 2,16 C2,8.2680135 8.2680135,2 16,2 C23.7319865,2 30,8.2680135 30,16 C30,23.7319865 23.7319865,30 16,30 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewJsa);
export default __webpack_public_path__ + "static/media/new-jsa.8db3f6d8.svg";
export { ForwardRef as ReactComponent };